import Vue from 'vue'
import HomeApp from './ThemeAqyActivity'

/* eslint-disable no-new */
new Vue({
    el: '#home-app',
    template: '<HomeApp/>',
    components: { HomeApp }
})


// WEBPACK FOOTER //
// ./src/h5/themeaqy_activity/indexaqy_activity.js